(function() { window.GUID_681ee024_bf65_4377_bd5b_3335770fcc11 = { getGuid: function() { return "681ee024-bf65-4377-bd5b-3335770fcc11"; } }; })();
var CS;
(function (CS) {
    class ScanEntryHelper {
        constructor(inputCountBeforeRaiseOnScan = 4, speedDetectionMilliseconds = 100) {
            this.enteredCharSpeed = [];
            this.lastInputTime = null;
            this.inputCountBeforeRaiseOnScan = inputCountBeforeRaiseOnScan;
            this.SpeedDetectionMilliseconds = speedDetectionMilliseconds;
        }
        GrabInput(key) {
            // do not count for scan for Arrow keys and enter and special keys
            if (key == 8 || key == 9 || key == 13 || key == 16 || key == 17 || key == 18 || key == 27 || key == 32 || key == 33 || key == 34 || key == 35 || key == 36 || key == 37 || key == 38 || key == 39 || key == 40 || key == 46 || key == 45) {
                return;
            }
            var me = this;
            if (this.lastInputTime == null) {
                this.lastInputTime = new Date();
                this.inputCount = 1;
                this.Input = String.fromCharCode(key);
            }
            else {
                this.inputCount += 1;
                this.Input += String.fromCharCode(key);
            }
            if (this.inputCount >= this.inputCountBeforeRaiseOnScan && !this.IsScanned) {
                var now = new Date();
                this.scannedSpeed = now.getTime() - this.lastInputTime.getTime();
                if (this.scannedSpeed <= this.SpeedDetectionMilliseconds) {
                    this.IsScanned = true;
                }
            }
            this.lagTimeoutId = CS.LagLocal(this.lagTimeoutId, this.SpeedDetectionMilliseconds + 5, function () {
                me.lastInputTime = null;
                me.inputCount = 0;
                if (me.IsScanned) {
                    me.Scan(me.scannedSpeed);
                }
                me.scannedSpeed = 0;
                me.IsScanned = false;
            });
        }
    }
    CS.ScanEntryHelper = ScanEntryHelper;
})(CS || (CS = {}));

//# sourceMappingURL=ScanEntryHelper.js.map
